import { render, staticRenderFns } from "./PermanenciaDocentePage.vue?vue&type=template&id=1dd37b6a"
import script from "./PermanenciaDocentePage.js?vue&type=script&lang=js&external"
export * from "./PermanenciaDocentePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports